import { post } from '@core/api/baseApi';
import { PostSendNotificationResponse, CustomErroHandlerResponse } from '@core/types';
import { NewUserNotificationPayload } from '@core/types/Notification';

export const sendNotification = async (
  payload: NewUserNotificationPayload,
): Promise<PostSendNotificationResponse | CustomErroHandlerResponse> =>
  await post(`/Users/notification`, payload);
